import Helpers from '../modules/Helpers'

class StarRating {
    constructor(el) {
        this.input = document.getElementById(el.getAttribute('aria-controls'))

        this.stars = el.getElementsByClassName('star-rating__star')
        return this
    }

    activate() {
        this.listeners()

        return this
    }

    listeners() {
        new Helpers(this.stars).eventListener((e) => {
            const rating = parseInt(e.currentTarget.getAttribute('data-rating'))
            this.set(rating)
            return this
        })
    }

    clear() {
        new Helpers(this.stars).removeClass('star-rating__star--active')
        this.input.value = ''
        return this
    }

    set(rating) {
        this.clear()
        this.input.value = rating
        const activeStars = Array.from(this.stars).filter(star => parseInt(star.getAttribute('data-rating')) <= rating)
        new Helpers(activeStars).addClass('star-rating__star--active')
        return this
    }
}

Array.from(document.getElementsByClassName('star-rating')).forEach((el) => {
    new StarRating(el).activate()
})

export default StarRating